export default function ToggleHelpNavDirective() {
  return {
    template: require('./toggle-nav.directive.html'),
    transclude: true,
    restrict: 'E',
    controller: ['$scope', 'helpItemsService', function ($scope, helpItemsService) {
      $scope.class = function () {
        return helpItemsService.isShowingHelpSideNav() ? "is-active" : "";
      };

      $scope.click = function () {
        helpItemsService.toggleHelpSideNav();
      };
    }]
  };
}